import { useEffect, useState } from "react";
import { Background } from "../../../shared/ui/background";
import { NavBar } from "../../../shared/ui/navbar";
import { TabSliding } from "../../../shared/ui/tab-sliding";
import { Title } from "../../../shared/ui/title";

import "./store-view.scss";
import { OffersPage } from "../../ui/store-offers";
import { CoinsPage } from "../../ui/store-coins";
import { useAppSelector } from "../../../hooks/hooks";
import {
  selectInit,
  selectLanguage,
  selectTranslations,
} from "../../../shared/data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../utils/translation";
import { useLocation } from "react-router-dom";
import useAmbientSound from "../../../utils/hooks/use-ambient-sound";

export function StoreView() {
  const [tab, setTab] = useState("offers");
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);
  const location = useLocation();
  const init = useAppSelector(selectInit);
  const buyingDisabled = init?.features?.disableBuyCredits;

  useAmbientSound("home");

  useEffect(() => {
    if (location.state === "coins") {
      setTab("coins");
    }
  }, [location]);

  return (
    <div id="store">
      <Background type="home">
        <NavBar hasAvatar></NavBar>
        <Title>{checkTranslationKey(translations[lang]?.Store, "Store")}</Title>
        <div className="tab-area">
          <TabSliding
            tabChange={setTab}
            tab={tab}
            tabOptions={{
              offers: checkTranslationKey(translations[lang]?.Offers, "Offers"),
              ...(buyingDisabled
                ? {}
                : {
                    coins: checkTranslationKey(
                      translations[lang]?.Coins,
                      "Coins"
                    ),
                  }),
            }}
          ></TabSliding>
        </div>

        {tab === "offers" ? <OffersPage /> : <CoinsPage />}
      </Background>
    </div>
  );
}

export default StoreView;
